module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "listable": ""
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [(!_vm.isEdit) ? [_c('v-card-text')] : _vm._e(), _vm._v(" "), (_vm.isEdit) ? [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-textarea', {
    ref: "focused",
    attrs: {
      "label": "Название",
      "rows": "2",
      "persistent-hint": "",
      "hint": "Измените при необходимости название дела"
    },
    model: {
      value: (_vm.item.nameShort),
      callback: function($$v) {
        _vm.$set(_vm.item, "nameShort", $$v)
      },
      expression: "item.nameShort"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    ref: "focused",
    attrs: {
      "label": "Примечание",
      "rows": "5",
      "persistent-hint": "",
      "hint": "Показывается во 2-3 строчках списка"
    },
    model: {
      value: (_vm.item.notes),
      callback: function($$v) {
        _vm.$set(_vm.item, "notes", $$v)
      },
      expression: "item.notes"
    }
  })], 1)], 1)], 1)], 1)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69e573ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assist/AssistForm.vue
// module id = 1164
// module chunks = 1